/*============================================================================
  Iron — toast de notification (remplace les alert() natifs du panier).
  API : window.IronToast.show(message). Filet de sécurité → alert() si le
  markup est absent. Auto-fermeture 5 s, pause au survol/focus, fermeture
  au clic sur la croix, sur la carte, ou via Échap.
  Markup + styles : snippet iron-toast.liquid (rendu une fois dans theme.liquid).
==============================================================================*/
(function () {
  if (window.IronToast) return;

  var DURATION = 5000;
  var timer = null;

  function node() { return document.querySelector('[data-iron-toast]'); }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function restartBar(root) {
    var bar = root.querySelector('[data-iron-toast-bar]');
    if (!bar) return;
    bar.style.animation = 'none';
    bar.style.animationPlayState = ''; // purge une éventuelle pause inline
    void bar.offsetWidth; // force un reflow pour rejouer l'animation
    bar.style.animation = '';
  }

  var IronToast = {
    show: function (message) {
      var root = node();
      if (!root) { window.alert(message); return; } // filet de sécurité

      // Réinitialise pour rejouer l'entrée + la barre de progression.
      root.classList.remove('is-visible');
      void root.offsetWidth;
      root.classList.add('is-visible');
      restartBar(root); // repart d'une barre propre (purge pause éventuelle)

      // Texte posé une fois la carte visible (dans l'arbre a11y) pour que
      // la région role="alert" l'annonce au lecteur d'écran.
      var msg = root.querySelector('[data-iron-toast-msg]');
      if (msg) { msg.textContent = message; }

      this._arm();
    },

    hide: function () {
      var root = node();
      if (!root) return;
      clearTimeout(timer);
      root.classList.remove('is-visible');
    },

    _arm: function () {
      clearTimeout(timer);
      timer = setTimeout(function () { IronToast.hide(); }, DURATION);
    },

    _pause: function () {
      clearTimeout(timer);
      var root = node();
      var bar = root && root.querySelector('[data-iron-toast-bar]');
      if (bar) { bar.style.animationPlayState = 'paused'; }
    },

    _resume: function () {
      var root = node();
      if (!root || !root.classList.contains('is-visible')) return;
      if (!reduceMotion()) { restartBar(root); }
      this._arm();
    }
  };

  window.IronToast = IronToast;

  function bind() {
    var root = node();
    if (!root) return;

    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-iron-toast-close]')) {
        IronToast.hide();
      }
    });

    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && root.classList.contains('is-visible')) {
        IronToast.hide();
      }
    });

    var inner = root.querySelector('.iron-toast__inner') || root;
    inner.addEventListener('mouseenter', function () { IronToast._pause(); });
    inner.addEventListener('mouseleave', function () { IronToast._resume(); });
    inner.addEventListener('focusin', function () { IronToast._pause(); });
    inner.addEventListener('focusout', function () { IronToast._resume(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
